import { Injectable } from '@angular/core';
import { AnalyticsRangeContext } from '@services/analytics-services/core';
import { map, Observable, tap } from 'rxjs';
import { ShippingAnalyticsService } from '@services/analytics-services/shipping/shipping-analytics.service';
import { summarize } from '@services/analytics-services/core/analytics.helper';

@Injectable()
export class ShippingAnalyticsCharts {
  constructor(private readonly shippingAnalyticsService: ShippingAnalyticsService) {}

  //changed for bar chart//
  getShippingByCourierCharts(context: AnalyticsRangeContext): Observable<any[]> {
    return this.shippingAnalyticsService.getOrderShippedByCourier(context).pipe(
      tap(({ list }) => list.sort((a: any, b: any) => b.orders_shipped - a.orders_shipped)), // Sorting
      map(({ list }) =>
        summarize(list, {
          labelKey: 'courier',
          valueKey: 'orders_shipped',
          limit: 10, // Applying the limit
        })
      ),
      map(list =>
        list.map((item: any) => ({
          label: item.courier,
          value: item.orders_shipped,
        }))
      )
    );
  }

  getAverageDeliveryByCourierCharts(context: AnalyticsRangeContext): Observable<any[]> {
    return this.shippingAnalyticsService.getShippingByCourier(context).pipe(
      tap(({ list }) => list.sort((a: any, b: any) => b.avg_delivery_time - a.avg_delivery_time)), // Sorting
      map(({ list }) =>
        summarize(list, {
          labelKey: 'courier',
          valueKey: 'avg_delivery_time',
          limit: 10, // Applying the limit
        })
      ),
      map(list =>
        list.map((item: any) => ({
          label: item.courier,
          value: item.avg_delivery_time,
        }))
      )
    );
  }
}
